export const HIERARCHY = 'HIERARCHY';
export const CASE = 'ccase';
export const LOAN = 'loan';
export const ACTIVITY = 'activity';
export const SUPERVISOR_REVIEW = 'supervisorReview';

export const pendingActivitiesPayload = {
  filters: {
    callMedium: '[{"code":"TELE_CALLING","name":"Tele Calling"}]',
    stateId: '[{"code":"IN_PROGRESS","name":"In Progress"}]',
    activityCategory: '[{"code":"WORKFLOW","name":"Workflow"}]',
  },
  page: {
    pageSize: 50,
    pageNumber: 1,
  },
};

export const BASE_URL = '/vymo/v3/workflow';
